import React from "react";

function BigError(props) {
  return (
    <div className="d-flex align-items-center justify-content-center mh100">
      <div className="w-75 card card-custom wave  wave-danger mb-8 mb-lg-0">
        <div className="card-body">
          <div className="d-flex align-items-center p-5">
            <div className="mr-6">
              <span className="svg-icon svg-icon-danger svg-icon-4x">
                <svg
                  width="24px"
                  height="24px"
                  viewBox="0 0 24 24"
                  version="1.1"
                >
                  <g
                    stroke="none"
                    strokeWidth="1"
                    fill="none"
                    fillRule="evenodd"
                  >
                    <rect x="0" y="0" width="24" height="24" />
                    <path
                      d="M14.8520384,9 L15.7780576,12 L8.22196243,12 L9.14797495,9 L14.8520384,9 Z M13.9260192,6 L10.0739875,6 L10.7050601,3.95551581 C10.8804029,3.38745846 11.4054966,3 12,3 C12.5945036,3 13.1195978,3.38745798 13.2949418,3.95551522 L13.9260192,6 Z M16.7040768,15 L17.9387691,19 L6.06126654,19 L7.2959499,15 L16.7040768,15 Z"
                      fill="#000000"
                    />
                    <rect
                      fill="#000000"
                      opacity="0.3"
                      x="3"
                      y="20"
                      width="18"
                      height="2"
                      rx="1"
                    />
                  </g>
                </svg>
              </span>
            </div>
            <div className="d-flex flex-column">
              <div className="text-dark   font-weight-bold font-size-h4 mb-3">
                {props.title}
              </div>
              <div className="text-dark-75">{props.message}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BigError;
